import React, { ReactNode, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LCFlexContainer from '../../../../components/Layout/LCFlexContainer';
import LCFlexItem from '../../../../components/Layout/LCFlexItem';
import WorkService, { Validate } from '../../../../services/WorkService/WorkService';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';
import { SolicitationView } from '../../../../models/SolicitationView';
import { WorkView } from '../../../../models/WorkView';
import WorkTeamService from '../../../../services/WorkTeamService/WorkTeamService';
import HeyHoUserService from '../../../../services/HeyHoUserService/HeyHoUserService';
import { WorkTeam } from '../../../../models/WorkTeam';
import { PPDropDown, PPMultiSelect, PPTextField } from 'processor-plataform-ui';
import WorkTypeService from '../../../../services/WorkTypeService/WorkTypeService';
import { WorkGroupType } from '../../../../models/WorkGroupType';
import { WorkType } from '../../../../models/WorkType';
import LcLoading from '../../../../components/Generic/LcLoading';
import Modal from '../../../../components/Dialog/Modal';

interface PropsWorkList {
    solicitation: SolicitationView;
    onCloseEvent: Function;
    open: boolean;
    content: string;
    confirmMessage: string;
    idConfirm?: string;
    abortMessage: string;
    idAbort?: string;
    aprovallWork: any
}

interface Option {
    label: string;
    value: string;
}

const NewWork: React.FC<PropsWorkList> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const workService = new WorkService(props);
    const workTeamService = new WorkTeamService(props);
    const heyHoUserService = new HeyHoUserService(props);
    const workTypeService = new WorkTypeService(props)

    const [optionsTeam, setOptionsTeam] = useState<Option[]>([]);
    const [workTeams, setWorkTeams] = useState<WorkTeam[]>([]);
    const [optionsUsers, setOptionsUsers] = useState<Option[]>([]);
    const [optionsWorkGroupType, setOptionsWorkGroupType] = useState<Option[]>([]);
    const [optionsWorkType, setOptionsWorkType] = useState<Option[]>([]);
    const [workGroupTypes, setWorkGroupTypes] = useState<WorkGroupType[]>([]);
    const [workTypes, setWorkTypes] = useState<WorkType[]>([]);
    const [work, setWork] = useState<WorkView>({} as WorkView);
    const [loadingUsers, setLoadingUsers] = useState<boolean>(false);
    const [loadingGeral, setLoadingGeral] = useState<boolean>(false);
    const [validations, setValidations] = useState<Validate[]>([]);
    const [loadingWorkType, setLoadingWorkType] = useState<boolean>(false);
    const [flowList, setFlowList] = useState<any[]>([]);
    const [approvalFlow, setApprovalFlow] = useState<boolean>(false);

    const mountDropList = (list: any[]) => {
        if (list.length > 0) {
            let _list = list.filter(c => (c.disabled) ? c.disabled === 0 || c.disabled === false : c)
                .map(c => {
                    return {
                        label: (c.nome) ? c.nome : ((c.name) ? c.name : c.description),
                        value: (c.idUser) ? c.idUser : c.id
                    }
                })
                .sort((a, b) => { return a.label > b.label ? 1 : -1 })

            return [..._list];
        }
        else {
            return [];
        }
    }

    const retrieveWorkGroupTypeService = async () => {
        try {
            var listworkGroupTypes = await workTypeService.getAllByServiceId(props.solicitation.idService as number);

            if (listworkGroupTypes.length == 0) {
                listworkGroupTypes = await workTypeService.getWorkGroupType(props.solicitation.idBusinessArea as number);
            }

            setWorkGroupTypes(listworkGroupTypes);
            setOptionsWorkGroupType(mountDropList(listworkGroupTypes));
        }
        catch (e) {
            console.warn(e);
            debugger
        }
    }

    const retrieveWorkTypeService = async () => {
        setLoadingWorkType(true);

        try {
            var listWorkTypes = await workTypeService.GetWorkTypes(work.idWorkGroupType as number);
            setWorkTypes(listWorkTypes);
            setOptionsWorkType(mountDropList(listWorkTypes));
        }
        catch (e) {
            console.warn(e);
            debugger
        }

        setLoadingWorkType(false);
    }

    const getApprovalFlowList = async (idApprovalFlow: number) => {
        try {
            var flowList_ = await workService.getApprovalList(props.solicitation.idBusinessArea, idApprovalFlow);
            setFlowList(flowList_.data)
        }
        catch (e) {
            console.warn(e);
            debugger
        }
    }

    const retrieveTeams = async () => {
        try {
            var listWorkTeams = await workTeamService.getWorkTeamByBusinessArea(props.solicitation.idBusinessArea as number);
            setWorkTeams(listWorkTeams);
            setOptionsTeam(mountDropList(listWorkTeams));
        }
        catch (e) {
            console.warn(e);
            debugger
        }
    }

    const retrieveUsers = async () => {
        setLoadingUsers(true);

        try {
            var listUsers = await heyHoUserService.getUsersAttendant(0, work.idWorkTeam as number);

            let list_: any[] = [];

            if (approvalFlow) {
                list_ = mountDropList(listUsers.filter(x => x.aprovador == true));
            }
            else {
                list_ = [{ label: "Sem atendente", value: 0 }].concat(mountDropList(listUsers));
            }

            setOptionsUsers(list_);
        }
        catch (e) {
            console.warn(e);
            debugger
        }

        setLoadingUsers(false);
    }

    const InitForm = async () => {
        setLoadingGeral(true);
        setLoadingUsers(false);
        setLoadingWorkType(false);
        setValidations([]);
        setOptionsTeam([]);
        setOptionsUsers([]);
        setOptionsWorkType([]);
        setOptionsWorkGroupType([]);
        setApprovalFlow(false);

        setWork({
            ...work,
            description: "",
            subject: "",
            idUser: 0,
            idWorkType: 0,
            idWorkTeam: 0,
            idWorkGroupType: 0
        });

        await Promise.all([
            retrieveTeams(),
            retrieveWorkGroupTypeService(),
            //retrieveUsers(),
            //retrieveWorkTypeService()
        ]);
        setLoadingGeral(false);
    }

    useEffect(() => {
        InitForm();
    }, []);

    useEffect(() => {
        if (props.aprovallWork) {
            setApprovalFlow(true);
            getApprovalFlowList(props.aprovallWork.idApprovalFlow);

            setWork({
                ...work,
                idWorkGroupType: props.aprovallWork.idWorkGroupType,
                idWorkType: props.aprovallWork.id,
                idWorkTeam: props.aprovallWork.idWorkTeam,
                subject: props.aprovallWork.description,
                idUser: props.aprovallWork.idUser
            });
        }
    }, [props.aprovallWork])

    const Save = async () => {
        if (workService.validateRules(work, setValidations) === false) {
            setLoadingGeral(false);
            return true;
        }

        setLoadingGeral(true);

        try {
            var workToSave: WorkView = {
                ...work,
                idSolicitation: props.solicitation.id,
                idUserRegistration: user.id as number,
                idStatus: 0,
                idUser: (work.idUser !== 0) ? work.idUser as number : null,
                description: work.description.replace(/(?:\r\n|\r|\n)/g, "<br/>")
            };

            if (approvalFlow) {
                const flowItem = flowList[0];

                setLoadingGeral(true);
                let usersAprover = work.idUser.map(aprover => aprover.value);

                workToSave = {
                    ...workToSave,
                    userListChangeManagementApprovers: usersAprover,
                    idWorkTypeYes: flowItem.idWorkTypeYes,
                    idUserYes: flowItem.idUserYes,
                    idWorkTeamYes: flowItem.idGroupResolverYes,
                    idWorkTypeNo: flowItem.idWorkTypeNo,
                    idWorkTeamNo: flowItem.idGroupResolverNo,
                    idUserNo: flowItem.idUserNo,
                    idFlowApproval: flowItem.id,
                    idUser: null,
                };
            }

            let resposePost = await workService.postWork(workToSave);
            resposePost.status === 200 && props.onCloseEvent && props.onCloseEvent(true);
        }
        catch (e) {
            debugger;
        }

        setLoadingGeral(false);
    }

    const changeData = async (event: any) => {
        const { name, value } = event.target;
        setWork({ ...work, [name]: value })
    };

    useEffect(() => {
        if (work.idWorkTeam > 0) {
            var workTemp = { ...work, idUser: 0 };
            setWork(workTemp);

            retrieveUsers();
        }
    }, [work.idWorkTeam]);

    const changeWorkGroupType = async () => {
        if (work.idWorkGroupType > 0) {
            var workTemp = {
                ...work,
                // idWorkType: 0,
                // subject: "",
                // idWorkTeam: 0,
                // idUser: 0
            }

            setWork(workTemp);
            await retrieveWorkTypeService();
        }
    }

    useEffect(() => {
        changeWorkGroupType();
    }, [work.idWorkGroupType]);

    useEffect(() => {
        if (work.idWorkType > 0) {
            var selectedWorkType = workTypes.filter(c => c.id === work.idWorkType).pop();

            if (selectedWorkType) {
                var workTemp = {
                    ...work,
                    subject: selectedWorkType?.description as string ?? "", //#######Aqui é invertido no Heyho3 tambem, description preenche subject#######
                    description: selectedWorkType?.subject as string ?? "", //########Aqui é invertido no Heyho3 tambem, description preenche subject##########
                    idWorkTeam: selectedWorkType?.idWorkTeam as number,
                }

                setWork(workTemp);

                if (selectedWorkType.idApprovalFlow != undefined) {
                    getApprovalFlowList(selectedWorkType.idApprovalFlow);
                }

                setApprovalFlow(selectedWorkType.idApprovalFlow != undefined);
            }
        }
    }, [work.idWorkType]);

    useEffect(() => {
        if (optionsWorkGroupType.length > 0 || optionsWorkType.length > 0 || optionsTeam.length > 0) {
            let work_ = work;

            if (optionsWorkGroupType.length === 1) work_ = { ...work_, idWorkGroupType: parseInt(optionsWorkGroupType[0].value) };
            if (optionsWorkType.length === 1) work_ = { ...work_, idWorkType: parseInt(optionsWorkType[0].value) };
            if (optionsTeam.length === 1) work_ = { ...work_, idWorkTeam: parseInt(optionsTeam[0].value) };

            setWork(work_);
        }
    }, [optionsWorkGroupType, optionsWorkType, optionsTeam])

    return (
        <Modal
            title={'Novo trabalho'}
            visible={props.open}
            close={() => { if (props.onCloseEvent != null) props.onCloseEvent(false); }}
        >
            <LcLoading loading={loadingGeral}>
                <LCFlexContainer spacing={2}>
                    <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                        <PPDropDown
                            required
                            openTrigger={'click'}
                            name={'idWorkGroupType'}
                            options={optionsWorkGroupType}
                            title={'Grupo de tipos de trabalho'}
                            placeholder={"Grupo de tipos de trabalho"}
                            placeholderSearch={'Buscar grupo de tipos de trabalho'}
                            onChange={changeData}
                            value={work.idWorkGroupType ? work.idWorkGroupType : '0'}
                            error={{
                                show: validations.find(x => 'idWorkGroupType' === x.name) !== undefined,
                                help: `${validations.find(x => 'idWorkGroupType' === x.name)?.validateMessage}`
                            }}
                        />
                    </LCFlexItem>

                    <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                        <LcLoading loading={loadingWorkType}>
                            <PPDropDown
                                required
                                openTrigger={'click'}
                                readOnly={(!(optionsWorkType && optionsWorkType.length > 0))}
                                name={'idWorkType'}
                                options={optionsWorkType}
                                title={'Tipo de trabalho'}
                                placeholder={"Tipos de trabalho"}
                                placeholderSearch={'Buscar tipos de trabalho'}
                                onChange={changeData}
                                value={work.idWorkType ? work.idWorkType : ''}
                                error={{
                                    show: validations.find(x => 'idWorkType' === x.name) !== undefined,
                                    help: `${validations.find(x => 'idWorkType' === x.name)?.validateMessage}`
                                }}
                            />
                        </LcLoading>
                    </LCFlexItem>

                    <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                        <PPDropDown
                            required
                            openTrigger={'click'}
                            name={'idWorkTeam'}
                            options={optionsTeam}
                            title={'Equipe'}
                            placeholder={"Selecione uma equipe"}
                            placeholderSearch={'Buscar equipe'}
                            onChange={changeData}
                            value={work.idWorkTeam > 0 ? work.idWorkTeam : ""}
                            error={{
                                show: validations.find(x => 'idWorkTeam' === x.name) !== undefined,
                                help: `${validations.find(x => 'idWorkTeam' === x.name)?.validateMessage}`
                            }}
                        />

                    </LCFlexItem>

                    <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                        <LcLoading loading={loadingUsers}>
                            {
                                approvalFlow
                                    ? <PPMultiSelect
                                        name={'idUser'}
                                        openTrigger={'click'}
                                        readOnly={(!(optionsUsers && optionsUsers.length > 0))}
                                        options={optionsUsers}
                                        title={'Aprovador'}
                                        placeholder={'Selecione um aprovador'}
                                        placeholderSearch={'Buscar aprovador'}
                                        onChange={changeData}
                                        error={{
                                            show: validations.find(x => 'idUser' === x.name) !== undefined,
                                            help: `${validations.find(x => 'idUser' === x.name)?.validateMessage}`
                                        }}
                                    />
                                    : <PPDropDown
                                        name={'idUser'}
                                        openTrigger={'click'}
                                        readOnly={(!(optionsUsers && optionsUsers.length > 0))}
                                        options={optionsUsers}
                                        title={'Atendente'}
                                        placeholder={'Selecione um atendente'}
                                        placeholderSearch={'Buscar atendente'}
                                        onChange={changeData}
                                        value={work.idUser ? work.idUser : ''}
                                        error={{
                                            show: validations.find(x => 'idUser' === x.name) !== undefined,
                                            help: `${validations.find(x => 'idUser' === x.name)?.validateMessage}`
                                        }}
                                    />
                            }
                        </LcLoading>
                    </LCFlexItem>

                    <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                        <PPTextField
                            required
                            onChange={changeData}
                            name={'subject'}
                            label={'Assunto'}
                            placeholder={"Assunto do trabalho"}
                            value={work.subject}
                            // value={work.subject}
                            autoComplete={"off"}
                            help={validations.find(x => 'subject' === x.name)?.validateMessage}
                            error={validations.find(x => 'subject' === x.name) !== undefined}
                        />
                    </LCFlexItem>

                    <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                        <PPTextField
                            required
                            multiline
                            onChange={changeData}
                            label={'Detalhes'}
                            name={'description'}
                            minRows={4}
                            maxRows={4}
                            value={work.description}
                            // value={work.description}
                            help={validations.find(x => 'description' === x.name)?.validateMessage}
                            error={validations.find(x => 'description' === x.name) !== undefined}
                        />
                    </LCFlexItem>

                    <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                        <div className={"row end"}>
                            <button
                                style={{ margin: '10px' }}
                                className={'lc-button bg-info'}
                                id={'Ok'}
                                onClick={() => Save()}
                                color={"primary"}>
                                Ok
                            </button>
                            <button
                                style={{ margin: '10px' }}
                                className={'lc-button bg-info-alt'}
                                id={'Cancelar'}
                                onClick={() => {
                                    if (props.onCloseEvent !== null) props.onCloseEvent(false);
                                }}
                                color={"primary"}>
                                Cancelar
                            </button>
                        </div>
                    </LCFlexItem>
                </LCFlexContainer>
            </LcLoading >
        </Modal >
    );
};

export default NewWork;